import { Link } from "react-router-dom";
import { NAV, SITE } from "@/data/site";
import { scrollToId } from "@/lib/scroll";

const linkCls = "text-sm text-white/70 transition-colors hover:text-tl-orange";
const headingCls = "font-mono-tl text-[11px] uppercase tracking-[0.3em] text-tl-orange";

const LEGAL = [
    { id: "privacy", to: "/privacy-policy", label: "Privacy Policy" },
    { id: "cookie", to: "/cookie-policy", label: "Cookie Policy" },
];

const FooterBrand = () => (
    <div>
        <div className="flex items-center gap-2.5">
            <img src="/assets/logo-mark.png" alt="Logo TECNO-LAV" className="h-9 w-9 object-contain mix-blend-screen" />
            <span className="font-display text-lg font-extrabold tracking-tight text-white">
                TECNO<span className="text-tl-orange">-</span>LAV
            </span>
        </div>
        <p className="mt-3 max-w-xs text-sm text-tl-mutedLight">{SITE.tagline}</p>
        <p className="mt-4 font-mono-tl text-[11px] uppercase tracking-[0.2em] text-white/40">
            {SITE.address} — {SITE.vat}
        </p>
    </div>
);

const FooterNav = () => (
    <nav aria-label="Link footer" className="flex flex-col gap-6 sm:flex-row sm:gap-16">
        <div>
            <p className={headingCls}>Navigazione</p>
            <ul className="mt-4 space-y-2.5">
                {NAV.map((item) => (
                    <li key={item.id}>
                        {item.to ? (
                            <Link data-testid={`footer-link-${item.id}`} to={item.to} className={linkCls}>
                                {item.label}
                            </Link>
                        ) : (
                            <button
                                type="button"
                                data-testid={`footer-link-${item.id}`}
                                onClick={() => scrollToId(item.id)}
                                className={linkCls}
                            >
                                {item.label}
                            </button>
                        )}
                    </li>
                ))}
            </ul>
        </div>
        <div>
            <p className={headingCls}>Legale</p>
            <ul className="mt-4 space-y-2.5">
                {LEGAL.map((l) => (
                    <li key={l.id}>
                        <Link data-testid={`footer-link-${l.id}`} to={l.to} className={linkCls}>
                            {l.label}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    </nav>
);

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-tl-dark3">
            <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-12">
                <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
                    <FooterBrand />
                    <FooterNav />
                </div>
                <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-xs text-white/40">© 2026 TECNO-LAV. Tutti i diritti riservati.</p>
                    <p className="font-mono-tl text-[11px] uppercase tracking-[0.2em] text-white/30">
                        Brivio — Lecco — Lombardia
                        <span className="mx-3 text-white/15">|</span>
                        <Link data-testid="footer-link-admin" to="/admin" className="transition-colors hover:text-tl-orange">
                            Area riservata
                        </Link>
                    </p>
                </div>
            </div>
        </footer>
    );
}
